"use client"

import { useRef, useState, useEffect, useCallback } from "react"
import {Link, useLocation, useNavigate} from "react-router-dom"
import { CircleUserRound, ChevronDown } from "lucide-react"
import logo from "../../assets/Logo.svg"
import "./NavBar.css"
import { useAuth } from "../../utils/AuthContext"
import { getUserData } from "../../utils/auth"
import NotificationBell from "./NotificationBell";

const Navbar = () => {
    const { handleSignOut, setHasJustSignedOut } = useAuth()
    const user = getUserData()
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const dropdownRef = useRef(null)
    const navigate = useNavigate()
    const location = useLocation()

    const toggleDropdown = () => setDropdownOpen((prev) => !prev)
    const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev)

    const handleClickOutside = useCallback((event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false)
        }
    }, [])
    const onSignOut = () => {
        handleSignOut()
        setDropdownOpen(false)
        setHasJustSignedOut(true)
        navigate("/")
    }

    useEffect(() => {
        if (dropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside)
        } else {
            document.removeEventListener("mousedown", handleClickOutside)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [dropdownOpen, handleClickOutside])

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <div onClick={() => navigate("/")} className="navbar-logo">
                    <img src={logo || "/placeholder.svg"} alt="CO"/>
                    <span className="logo-text">NTACTAME</span>
                </div>
            </div>

            <div className="navbar-tagline">
                <span>EL CONTACTO QUE BUSCÁS PARA TU HOGAR, <b><i>EN SEGUNDOS</i></b></span>
            </div>

            <div className="navbar-buttons">
                {user ? (
                    <>
                    <NotificationBell />
                    <div className="navbar-profile" style={{cursor: "pointer"}} ref={dropdownRef}
                         onClick={toggleDropdown}>
                        <CircleUserRound size="25"/>
                        <div className="navbar-greeting">
                            Hola, {user.email.split('@')[0]}
                        </div>
                        <ChevronDown className="dropdown-arrow"/>

                        {dropdownOpen && (
                            <div className="dropdown-menu">
                                <Link to="/usuario/perfil" className="dropdown-item"> MI PERFIL</Link>
                                <div className="dropdown-item" onClick={onSignOut}>CERRAR SESIÓN</div>
                            </div>
                        )}
                    </div>
                    </>
                ) : (
                    <>
                        <div className={`hamburger ${mobileMenuOpen ? "open" : ""}`} onClick={toggleMobileMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
                            <button
                                onClick={() => {
                                    navigate("/login", {state: {from: location.pathname}});
                                    toggleMobileMenu()
                                }}
                                className="navbar-button"
                            >
                                INICIAR SESIÓN
                            </button>
                            <button
                                onClick={() => {
                                    navigate("/registro")
                                    toggleMobileMenu()
                                }}
                                className="navbar-button-r"
                            >
                                REGISTRARME
                            </button>
                        </div>
                        <div className="desktop-buttons">
                            <button onClick={() => navigate("/login", {state: {from: location.pathname}})}
                                    className="navbar-button">
                                INICIAR SESIÓN
                            </button>
                            <button onClick={() => navigate("/registro")} className="navbar-button-r">
                                REGISTRARME
                            </button>
                        </div>
                    </>
                )}
            </div>
        </nav>
    )
}

export default Navbar